import { SkipNavContent } from "@reach/skip-nav";
import { HeadingPriority } from "atoms/constants/heading-priority";
import Heading from "atoms/typography/heading";
import { siteMap } from "internal-sitemap";
import RouteTabs from "molecules/route-tabs/route-tabs";
import BreadcrumbsMenu from "organisms/breadcrumbs/breadcrumbs-menu";
import useMyLiNKTabs from "pages/my-link/use-my-link-tabs";
import React from "react";
import { Redirect } from "react-router";
import useMyLiNKDefaults from "utilities/hooks/domain/my-link/use-my-link-defaults";
import useCultureCodeRoute from "utilities/hooks/routing/use-culture-code-route";
import { RouteUtils } from "utilities/route-utils";
import { NestedRoutesProps } from "utilities/routing/nested-route";

interface MyBookmarksDashboardProps extends NestedRoutesProps {}
const CSS_CLASS_NAME = "c-my-bookmarks-dashboard";

const MyBookmarksDashboard = (props: MyBookmarksDashboardProps) => {
    const { generateCultureCodedRoute } = useCultureCodeRoute();
    const { tabs } = useMyLiNKTabs();

    const { defaultBookmarkViewByPillRoute } = useMyLiNKDefaults();

    if (
        RouteUtils.assertCurrentUrl(
            generateCultureCodedRoute(siteMap.myLink.myBookmarks.by.dashboard)
        ) ||
        RouteUtils.assertCurrentUrl(
            generateCultureCodedRoute(siteMap.myLink.myBookmarks.dashboard)
        )
    ) {
        // Redirect to default pill nav (current View All, but assume eventually Publications)
        return (
            <Redirect
                to={generateCultureCodedRoute(defaultBookmarkViewByPillRoute)}
            />
        );
    }

    if (
        RouteUtils.assertCurrentUrlContains(
            generateCultureCodedRoute(siteMap.myLink.collections)
        )
    ) {
        // Redirect to collections pill nav
        return (
            <Redirect
                to={generateCultureCodedRoute(
                    siteMap.myLink.myBookmarks.by.collection
                )}
            />
        );
    }

    return (
        <>
            <BreadcrumbsMenu fullWidth={true} />
            <SkipNavContent tabIndex={-1}>
                <div className={CSS_CLASS_NAME}>
                    <Heading
                        cssClassName={`${CSS_CLASS_NAME}__heading`}
                        priority={HeadingPriority.Five}>
                        MyLiNK
                    </Heading>
                    <RouteTabs
                        redirectIfNotFound={false}
                        routes={props.routes}
                        tabs={tabs}
                    />
                </div>
            </SkipNavContent>
        </>
    );
};

export default MyBookmarksDashboard;
